import 'bootstrap/dist/css/bootstrap.css';

import React from 'react';
import { BrowserRouter as Router, Route, Routes, BrowserRouter } from 'react-router-dom';
import Home from './components/Home';
import WorkerList from './components/WorkerList';
import JobList from './components/JobList';
import WorkerRecommendation from './components/WorkerRecommendation';
import MessageComponent from './components/Messages';
import VideoCallComponent from './components/videoCallComponent';
import JobManagement from './components/JobManagement';
import 'jquery/dist/jquery.min.js'
import 'bootstrap/dist/js/bootstrap.min.js'

import Navbar from './components/navbar';
import Navbar1 from './components/Navbar1';
import Service from './components/Service';
import Signup from './components/SignUp';
import Signin from './components/Signin';
import Logout from './components/Logout';
import PostJob from './components/Postjob';

import ApplyForJob from './components/ApplyForJob';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './assets/css/style.css';
import Navbar2 from './components/Navbar2';
import QRScanner from './components/QRScanner';
import AdminDashboard from './components/admin/AdminDashboard';
import WorkerRegistration from './components/WorkerRegistration';
import Login from './components/Login';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './context/PrivateRoute';
import WorkerDetail from './components/WorkerDetail';
import UserRoute from './context/UserRoute';

function App() {
  return (
    <>
    <BrowserRouter>
   
    
    <div className='wrapper'> 
    <Navbar2 />
    </div>
            
    
      <Routes>
    
      
        <Route path="/" element={<Home />} />
        <Route path="/workers" element={<UserRoute><WorkerList /></UserRoute>} />
        
        <Route path='/service' element={<Service/>}/>
        <Route path="/jobs" element={<JobList />} />
        <Route path="/workers-recommend" element={<WorkerRecommendation />} />
        <Route path="/message" element={<MessageComponent />} />
        <Route path="/videocall" element={<VideoCallComponent />} />
        <Route path="/job-management" element={<JobManagement />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/postjob" element={<PostJob />} />
        <Route path="/applyjob" element={<ApplyForJob />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/attendance" element={<UserRoute><QRScanner /></UserRoute>} />
        <Route path='/admin' element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
        <Route path='/worker-registration' element={<PrivateRoute><WorkerRegistration /></PrivateRoute>} />
        <Route path='/login' element={<Login />} />
       

        <Route path="/workers/:workerId" element={<UserRoute><WorkerDetail /></UserRoute>} />
        
        
        
      </Routes>
    
    <Footer />
    
 
    
    
    </BrowserRouter>
    
    </>
  );
}

export default App;
